import React, { useRef } from 'react';
import { Link } from 'react-scroll';
import breakPoints, { colors } from 'helpers/Styles';
import { useRouter } from 'next/router';
const ProductFilter = ({
  type,
  listIndex,
  item,
  handleActiveNav,
  activeNav,
  fullWidth,
}) => {
  const router = useRouter();
  let data = router.query;
  let params = '';

  if (typeof data.category !== 'undefined' && type === 'category')
    params = data[type].split(',');
  if (typeof data.cpu !== 'undefined' && type === 'cpu')
    params = data[type].split(',');
  if (typeof data.gpu !== 'undefined' && type === 'gpu')
    params = data[type].split(',');
  if (typeof data.price_range !== 'undefined' && type === 'price_range')
    params = [data[type]];
  if (typeof data.sort_by !== 'undefined' && type === 'sort_by')
    params = [data[type]];

  const stickLinkRef = useRef();
  const setActiveMobile = () => {
    stickLinkRef.current?.scrollIntoView({
      inline: 'center',
    });
    handleActiveNav(listIndex, type, item);
  };

  const setActiveDesktop = () => {
    handleActiveNav(listIndex, type, item);
  };

  const classNameReturn = () => {
    if (
      (type === 'price_range' ||
        type === 'sort_by' ||
        type === 'cpu' ||
        type === 'category' ||
        type === 'gpu') &&
      params?.includes(item.toLowerCase())
    )
      return 'myBtnContainer active_link';
    else return 'myBtnContainer';
  };
  const functionName = () => {
    if (
      (type === 'price_range' ||
        type === 'sort_by' ||
        type === 'cpu' ||
        type === 'category' ||
        type === 'gpu') &&
      params?.includes(item.toLowerCase())
    )
      return handleActiveNav(listIndex, type, item, 'remove');
    else return handleActiveNav(listIndex, type, item);
  };
  return (
    <>
      <div className={classNameReturn()} key={listIndex}>
        <Link
          onSetActive={setActiveDesktop}
          onClick={() => functionName()}
          to={item}
          spy
          smooth
          offset={-130}
          duration={1000}
          delay={0}
        >
          <button className={`link_text ${fullWidth ? 'fullWidth' : ''}`}>
            {item}
          </button>
        </Link>
      </div>
      <style>
        {`
        .active_link button {
          border: 1px solid #FD0300 !important;
          font-family: 'Roboto-Bold';
        }
        
        .myBtnContainer {
          max-width: 465px;
          margin: 0px auto;
        }
        .myBtnContainer button {
          padding: 10px 15px;
          font-family: 'Roboto-Medium';
          font-style: normal;
          font-weight: 400;
          font-size: 13px;
          line-height: 20px;
          text-transform: uppercase;
          background: #242424;
          border-radius: 4px;
          color: #E4E4E4;
          margin: 0px 7px 12px;
          border: 1px solid transparent;
      }
      
        .fullWidth {
          width: 100%;
          margin: 10px auto !important;
        }
      }
        label.clear {
          display: flex;
          align-items: center;
        }

        .myBtnContainer {
          max-width: 465px;
          margin: 0px auto;
        } 
        
        .myBtnContainer {
          max-width: 320px;
          margin: 0px auto;
          display: initial;
        }
        
      `}
      </style>
    </>
  );
};

export default ProductFilter;
